import React from 'react'
import ReportWrapper from '../ReportWrapper'
import ReportSectionHeading from '../ReportSectionHeading'
import LoanRecordsOverview from './LoanRecordsOverview'
import LendingInstitution from './LendingInstitution'
import LoanPortfolio from './LoanPortfolio'
import OverdueLoan from './OverdueLoan'
import SummarizedLoans from './SummarizedLoans'

interface LoanRecordsProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function LoanRecords({ data, title, sectionIndex }: LoanRecordsProps) {
  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <LoanRecordsOverview data={data} />
      <LendingInstitution data={data} />
      <LoanPortfolio data={data} />
      <OverdueLoan data={data} />
      <SummarizedLoans data={data} />
    </ReportWrapper>
  )
}
